import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BsFileEarmarkTextFill } from "react-icons/bs";

// Force paragraphs
const Block = ReactQuill.Quill.import("blots/block");
Block.tagName = "P";
ReactQuill.Quill.register(Block, true);

const Message = (props) => {
  const [message, setMessage] = useState(props.moreDetail || "");

  // Only sync when moreDetail truly changes
  useEffect(() => {
    setMessage(props.moreDetail || "");
  }, [props.moreDetail]);

  const handleChange = (content) => {
    setMessage(content);
    props.setMessage(content); // send to parent here only
  };

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image", "video", "formula"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
    clipboard: { matchVisual: false },
  };

  return (
    <div className={`col-lg-${props.size || 6}`}>
      <div className="form-group mt-3">
        <label className="col-sm-12 p-0">
          <BsFileEarmarkTextFill style={{ fontSize: "20px" }} /> {props.titles}:
        </label>

        <ReactQuill
          modules={modules}
          theme="snow"
          value={message}
          onChange={handleChange}
          readOnly={props.readOnly}
        />
      </div>
    </div>
  );
};

export default Message;
